import styled, { css } from 'styled-components';

/**
 * Surfaces shared by the banded service-page pieces (ServiceBlocks, ProofBand,
 * EstimateCard, the split FAQ and the project row).
 *
 * Kept in a module of its own, with no component imports, so FAQ (which the home
 * page loads eagerly) can use the shared eyebrow without pulling ServiceBlocks and
 * the project catalogue into that bundle.
 */

/** The white card surface: 20px radius, a Davinci Blue hairline, a Midnight-tinted shadow. */
export const cardSurface = css`
  background: var(--white);
  border: 1px solid rgba(11, 152, 206, 0.14);
  border-radius: 20px;
  box-shadow: 0 6px 20px rgba(20, 53, 98, 0.08);
`;

/**
 * The dark card: a radial Davinci Blue glow over Midnight, the pricing page's own
 * estimate-card recipe. White text on it is 12:1; Beach is for small caps on it.
 */
export const darkCardSurface = css`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 20px;
  color: var(--white);
  box-shadow: 0 18px 50px rgba(20, 53, 98, 0.16);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    background:
      radial-gradient(120% 70% at 85% -10%, rgba(11, 152, 206, 0.55), transparent 60%),
      linear-gradient(180deg, var(--davinci-midnight), rgb(16, 42, 79));
  }
`;

/** Small caps line above a section heading. Denim on white is 5.35:1, on the grey wash 4.7:1. Never under 13px. */
export const Eyebrow = styled.p`
  margin: 0 0 0.45rem;
  font-size: max(13px, var(--fs-xs));
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--davinci-denim);
`;
